import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Caret } from '../shapes';


const CaretRightSvg = (props) => (
  <g>
    <IconBounds />
    <Caret {...props} />
  </g>
);

CaretRightSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

CaretRightSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default CaretRightSvg;
